// extracted by mini-css-extract-plugin
export default {"inputBlock":"InputBlock_inputBlock__Qd7Zw","title":"InputBlock_title__AxQtd","input":"InputBlock_input__zyu+l","isColumnInput":"InputBlock_isColumnInput__rNVy6"};